export const CAPABILITIES = [
  {
    id: "nuclear",
    number: "01",
    title: "Nuclear Technology",
    lead: "Engineering the next generation of reactors, instrumentation, and fuel cycle technologies with an unwavering commitment to safety and precision.",
    items: [
      { name: "Reactor Engineering", desc: "Design, analysis, and lifecycle management of advanced fission and small modular reactor systems." },
      { name: "Radiation Detection", desc: "High-sensitivity detection instruments for research, medical, and defense applications." },
      { name: "Nuclear Instrumentation", desc: "Control systems, sensors, and monitoring platforms for critical nuclear infrastructure." },
      { name: "Fuel Cycle Technologies", desc: "Front-to-back fuel cycle solutions from enrichment to responsible waste management." },
      { name: "Nuclear Safety Systems", desc: "Passive and active safety architectures, probabilistic risk assessment, and containment engineering." },
      { name: "Regulatory Consulting", desc: "Licensing, compliance, and policy advisory for governments and commercial operators." },
    ],
    image: "https://images.unsplash.com/photo-1581093577421-f561a654a353?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "space",
    number: "02",
    title: "Space Research",
    lead: "From orbital systems to scientific payloads, we build the platforms that expand humanity's reach into space.",
    items: [
      { name: "Satellite Engineering", desc: "Bus design, integration, and flight qualification for LEO, MEO, and GEO missions." },
      { name: "Orbital Systems", desc: "Guidance, navigation, and control systems for autonomous orbital operations." },
      { name: "Mission Planning", desc: "End-to-end mission architecture, trajectory design, and operations planning." },
      { name: "Scientific Payload Development", desc: "Precision instruments for Earth observation, deep-space science, and astrophysics." },
      { name: "Advanced Space Materials", desc: "High-performance alloys, ceramics, and composites for extreme environments." },
      { name: "Ground Infrastructure", desc: "Telemetry, tracking, and command networks for global mission operations." },
    ],
    image: "https://images.unsplash.com/photo-1446776811953-b23d57bd21aa?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "minerals",
    number: "03",
    title: "Rare Metals & Strategic Minerals",
    lead: "Responsible discovery, extraction, and processing of the materials that power modern industry and clean energy.",
    items: [
      { name: "Geological Exploration", desc: "Advanced geophysical surveys and predictive modeling of mineral systems." },
      { name: "Rare Earth Elements", desc: "Separation, refinement, and supply of neodymium, dysprosium, and light REEs." },
      { name: "Strategic Metals", desc: "Sourcing and processing of titanium, tungsten, cobalt, and lithium for critical applications." },
      { name: "Mineral Processing", desc: "Hydrometallurgical and pyrometallurgical processing at commercial scale." },
      { name: "Sustainable Mining", desc: "Low-impact extraction methods, tailings reduction, and water stewardship." },
      { name: "Resource Assessment", desc: "Reserve estimation, feasibility studies, and long-range resource planning." },
      { name: "Supply Chain Optimization", desc: "Traceable, ethical supply chains from mine to manufacturing partner." },
    ],
    image: "https://images.unsplash.com/photo-1519074069444-1ba4fff66d16?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "research",
    number: "04",
    title: "Research & Innovation",
    lead: "Six global research programs advancing the science that underpins every Aurelius Dynamics capability.",
    items: [
      { name: "Nuclear Science Laboratory", desc: "Fundamental research into reactor physics, fusion, and radiation science." },
      { name: "Advanced Materials Research", desc: "Discovery of next-generation alloys, superconductors, and functional materials." },
      { name: "Space Systems Engineering", desc: "Systems-of-systems research for autonomous, resilient space architectures." },
      { name: "Robotics", desc: "Field robotics for extreme environments — reactors, orbit, and subsurface mining." },
      { name: "Artificial Intelligence", desc: "Applied AI for diagnostics, exploration, and mission autonomy." },
      { name: "Strategic Minerals Research", desc: "Metallurgy, separation chemistry, and circular material design." },
    ],
    image: "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?auto=format&fit=crop&w=1600&q=80",
  },
  {
    id: "sustainability",
    number: "05",
    title: "Sustainability",
    lead: "Ethical practice and long-term stewardship are not adjacent to our engineering — they define it.",
    items: [
      { name: "Responsible Mining", desc: "Community-first practices, restoration, and biodiversity protection." },
      { name: "Environmental Stewardship", desc: "Rigorous impact assessment and continuous emissions reduction." },
      { name: "Nuclear Safety", desc: "Defense-in-depth culture across every reactor and instrumentation program." },
      { name: "Ethical Supply Chains", desc: "Transparent, auditable material provenance from source to product." },
      { name: "Community Development", desc: "Long-term partnerships with the communities where we operate." },
      { name: "Corporate Governance", desc: "Independent oversight, ethical conduct, and full regulatory compliance." },
    ],
    image: "https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?auto=format&fit=crop&w=1600&q=80",
  },
];
